import type { PortfolioViewState } from '../types';

type LegacyTopPositionsFilterEnabledFields = {
  overviewTopPositionsFilterEnabled?: boolean;
};

export type PortfolioViewStateWithLegacyTopPositionsFilters = Partial<PortfolioViewState> &
  LegacyTopPositionsFilterEnabledFields;

/** Map legacy enabled flag to count-only Top N. Missing enabled is treated as off. */
function migrateLegacyTopPositionsFilterEnabled(
  count: number | undefined,
  enabled: boolean | undefined,
  defaultTopN: number
): number {
  if (count !== undefined) {
    return count;
  }
  return enabled === true ? defaultTopN : 0;
}

/**
 * Convert legacy Top Positions filter enabled flags to count-only state.
 * Preserves an explicit stored count (including 0). Does not mutate the input.
 */
export function migrateLegacyTopPositionsFilterState(
  viewState: PortfolioViewStateWithLegacyTopPositionsFilters | undefined,
  defaultTopN: number
): Partial<PortfolioViewState> {
  const { overviewTopPositionsFilterEnabled, ...rest } = (viewState ??
    {}) as PortfolioViewStateWithLegacyTopPositionsFilters;

  return {
    ...rest,
    overviewTopPositionsFilterCount: migrateLegacyTopPositionsFilterEnabled(
      viewState?.overviewTopPositionsFilterCount,
      overviewTopPositionsFilterEnabled,
      defaultTopN
    ),
    performanceTopPositionsFilterCount: viewState?.performanceTopPositionsFilterCount ?? 0,
  };
}
